<template>
  <article class="faqs__faq">
    <header class="faqs__faq-header" @click="open = !open">
        <span>{{ question }}</span>

        <img v-if="!open" class="faqs__faq-icon--open" src="/app/themes/cliftoncoffee/dist/images/open-plus.png" />
        <img v-if="open" class="faqs__faq-icon--close" src="/app/themes/cliftoncoffee/dist/images/close-line.png" />
      </header>
      <main class="faqs__faq-main" :style="contentStyle">  
        <p ref="inner" v-html="answer"></p>
      </main>
  </article>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      innerHeight: 250
    }
  },
  computed: {
    contentStyle () {
      if (this.open) {
        return 'height: ' + (this.contentHeight + 20) + 'px;'
      } else {
        return ''
      }
    }
  },
  mounted() {
    this.contentHeight = this.$refs.inner.clientHeight
  },
  props: {
    question: {
      type: String, 
      default: ''
    }, 
    answer: {
      type: String, 
      default: ''
    }
  }
}
</script>